import { iconsSources } from '../../helpers/icons';
import styles from './Message.module.css';
import { hideName } from '../../helpers/titreHelper';
import hum from '../../assets/images/logo.png';
import imgBg from '../../assets/images/imgBg.png';

const Message = ({
  message,
  titrTag,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  win,
  currentState,
  winId,
}) => {
  const errorHandler = (e) => {
    e.target.src = hum;
  };

  return (
    <div className={styles['wrapper']}>
      {message && (
        <div
          className={`${styles['blockMsg']} ${
            winId === message.id && currentState === 'S4' && styles['winnerBg']
          }`}>
          <div className={styles['blockImg']}>
            <img
              className={styles.photo}
              src={
                (message?.image !== '1' && message?.image && message?.image) ||
                hum
              }
              alt={message?.author}
              onError={errorHandler}
            />
            <img src={imgBg} alt="Кольцо фон" className={styles.imgBg} />
          </div>
          <div className={styles['nameAuthor']}>
            {hideName(message?.author.trim())}
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
